import { render } from "./PlaybookCreate.vue?vue&type=template&id=21bbac70&scoped=true"
import script from "./PlaybookCreate.vue?vue&type=script&lang=js"
export * from "./PlaybookCreate.vue?vue&type=script&lang=js"

import "./PlaybookCreate.vue?vue&type=style&index=0&id=21bbac70&scoped=true&lang=css"
import "./PlaybookCreate.vue?vue&type=style&index=1&id=21bbac70&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bbac70"]])

export default __exports__